import { createAction } from 'redux-actions';
import api from 'lib/api';
import { serialize } from 'lib/urlUtils';

const CLEAR_WAFFLES = 'waffle/CLEAR_WAFFLES';
const LOAD_PENDING = 'waffle/LOAD_PENDING';
const LOAD_ERROR = 'waffle/LOAD_ERROR';
export const INITIAL_SEARCH = 'waffle/INITIAL_SEARCH';
export const APPEND_SEARCH = 'waffle/APPEND_SEARCH';

export const appendSearch = createAction(APPEND_SEARCH);
export const clearWaffles = createAction(CLEAR_WAFFLES);
export const initialWaffles = createAction(INITIAL_SEARCH);

export const loadWafflesAction = (searchCriteria, TYPE_OF_SEARCH) => {
  const endpoint = `products/search${serialize(searchCriteria, false)}`;
  return api({
    endpoint,
    types: [LOAD_PENDING, TYPE_OF_SEARCH, LOAD_ERROR],
  });
};

const INITIAL_STATE = {
  waffles: [],
  aggregation: null,
  loading: false,
  error: null,
  pagination: null,
  isInitialSet: false,
};

export default function Waffle(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case LOAD_PENDING:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_WAFFLES:
      return {
        ...state,
        loading: false,
        waffles: [],
        pagination: null,
        error: null,
        aggregation: null,
        isInitialSet: false,
      };

    case INITIAL_SEARCH: {
      const { data: { search = null } = {} } = payload || {};
      if (!search || !payload) {
        return {
          ...state,
          loading: false,
          error: new Error('Fetching Waffle failed'),
        };
      }
      const { pagination, aggregation, items } = search;
      return {
        ...state,
        pagination,
        aggregation,
        waffles: items,
        error: null,
        loading: false,
        isInitialSet: true,
      };
    }

    case APPEND_SEARCH: {
      const { data: { search } = {} } = payload || {};
      if (!search || !payload) {
        return {
          ...state,
          loading: false,
          error: new Error('Fetching Waffle failed'),
        };
      }
      const { pagination, aggregation, items } = search;
      const tempWaffles = [...state.waffles, ...items];
      return {
        ...state,
        pagination,
        aggregation,
        waffles: tempWaffles,
        error: null,
        loading: false,
        isInitialSet: false,
      };
    }

    case LOAD_ERROR: {
      return {
        ...state,
        pagination: null,
        aggregations: null,
        waffles: [],
        error: null,
        loading: false,
        isInitialSet: false,
      };
    }

    default:
      return state;
  }
}
